import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const o = () => /* @__PURE__ */ s.jsx("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ s.jsx(
  "path",
  {
    d: "M20.71 3.655s1.942 -0.757 1.78 1.082c-0.053 0.758 -0.539 3.409 -0.917 6.277l-1.295 8.495s-0.108 1.244 -1.08 1.461c-0.971 0.216 -2.428 -0.758 -2.698 -0.974 -0.216 -0.162 -4.047 -2.597 -5.396 -3.787 -0.378 -0.325 -0.81 -0.974 0.054 -1.732l5.665 -5.411c0.648 -0.649 1.295 -2.164 -1.403 -0.325L7.866 13.88s-0.864 0.542 -2.482 0.055l-3.508 -1.082s-1.295 -0.811 0.917 -1.623c5.396 -2.543 12.034 -5.14 17.916 -7.575",
    fill: "currentColor"
  }
) });
export {
  o as T
};
